 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/bookdescription'
 import PRAISEFORKEVINJANDERSON from '@/components/praiseforkevinjanderson'
 import TITLEPAGE from '@/components/titlepage'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import INTRODUCTION from '@/components/introduction'
 import INTROTOMEMORIAL from '@/components/introtomemorial'
 import MEMORIAL from '@/components/memorial'
 import INTROTOROUGHDRAFT from '@/components/introtoroughdraft'
 import ROUGHDRAFT from '@/components/roughdraft'
 import INTROTOCOMBATEXPERIENCE from '@/components/introtocombatexperience'
 import COMBATEXPERIENCE from '@/components/combatexperience'
 import INTROTOESCAPEHATCH from '@/components/introtoescapehatch'
 import ESCAPEHATCH from '@/components/escapehatch'
 import INTROTONEXTBESTTHING from '@/components/introtonextbestthing'
 import THENEXTBESTTHINGTOBEINGTHERE from '@/components/thenextbestthingtobeingthere'
 import INTROTOTERMINAL from '@/components/intrototerminal'
 import TERMINAL from '@/components/terminal'
 import INTROTOCOLLABORATORS from '@/components/introtocollaborators'
 import COLLABORATORS from '@/components/collaborators'
 import INTROTOWHISPEROFCALADANSEAS from '@/components/introtowhisperofcaladanseas'
 import AWHISPEROFCALADANSEAS from '@/components/awhisperofcaladanseas'
 import INTROTOCHANGEOFMIND from '@/components/introtochangeofmind'
 import CHANGEOFMIND from '@/components/changeofmind'
 import INTROTOREFLECTIONSINAMAGNETICMIRROR from '@/components/introtoreflectionsinamagneticmirror'
 import REFLECTIONSINAMAGNETICMIRROR from '@/components/reflectionsinamagneticmirror'
 import INTROTOMAMMOTHDAWN from '@/components/introtomammothdawn'
 import MAMMOTHDAWN from '@/components/mammothdawn'
 import INTROTOJOBQUALIFICATIONS from '@/components/introtojobqualifications'
 import JOBQUALIFICATIONS from '@/components/jobqualifications'
 import INTROTOPARADOXGREENBLATT from '@/components/introtoparadoxgreenblatt'
 import PARADOXGREENBLATTATTORNEYSATLAW from '@/components/paradoxgreenblattattorneysatlaw'
 import INTROTOPRISONEROFWAR from '@/components/introtoprisonerofwar'
 import PRISONEROFWAR from '@/components/prisonerofwar'
 import LOVE_2 from '@/components/love_2'
 import INTROTOLOGENTRY from '@/components/introtologentry'
 import LOGENTRY from '@/components/logentry'
 import INTROTOMUSICPLAYEDONTHESTRINGSOFTIME from '@/components/introtomusicplayedonthestringsoftime'
 import MUSICPLAYEDONTHESTRINGSOFTIME from '@/components/musicplayedonthestringsoftime'
 import INTROTONEWTS from '@/components/introtonewts'
 import NEWTS from '@/components/newts'
 import INTROTOGHOSTSOFMARS from '@/components/introtoghostsofmars'
 import GHOSTSOFMARS from '@/components/ghostsofmars'
 import INTROTOHUMANMARTIANONETWOTHREE from '@/components/introtohumanmartianonetwothree'
 import HUMANMARTIANONETWOTHREE from '@/components/humanmartianonetwothree'
 import PREVIOUSPUBLICATIONINFORMATION from '@/components/previouspublicationinformation'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import IFYOULIKED from '@/components/ifyouliked'
 import ALSOBYKEVINJANDERSON from '@/components/alsobykevinjanderson'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/introtomemorial",
 			"name" : "introtomemorial",
 			"component" : INTROTOMEMORIAL
 		},
 		{
 			"path" : "/memorial",
 			"name" : "memorial",
 			"component" : MEMORIAL
 		},
 		{
 			"path" : "/introtoroughdraft",
 			"name" : "introtoroughdraft",
 			"component" : INTROTOROUGHDRAFT
 		},
 		{
 			"path" : "/roughdraft",
 			"name" : "roughdraft",
 			"component" : ROUGHDRAFT
 		},
 		{
 			"path" : "/introtocombatexperience",
 			"name" : "introtocombatexperience",
 			"component" : INTROTOCOMBATEXPERIENCE
 		},
 		{
 			"path" : "/combatexperience",
 			"name" : "combatexperience",
 			"component" : COMBATEXPERIENCE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js